import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoaderBusService } from './modules/loader/services/loader-bus/loader-bus.service';

/** The main starting component, containing the top most wrapper and loader.  */
@Component({
    selector: 'of-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  /** ignore */
  constructor(
    private _router: Router,
    private _loader: LoaderBusService,
  ) { }

  ngOnInit(): void {
    // Show the loader while navigating.
    this._loader.forceOnNavigate(this._router);
  }

}
